import type { ReactNode } from 'react';

import { GridContainer, GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';

import { LazyLoader } from './components/lazy-loader';

export const SearchContentContainer: React.FC<{
  filters: ReactNode;
  results: ReactNode;
  dataTestid?: string;
}> = ({ filters, results, dataTestid }) => (
  <Section data-testid={dataTestid}>
    <GridContainer variant="wide">
      <GridItem span={0} spanLarge={4}>
        {filters}
      </GridItem>
      <GridItem span={12} spanLarge={8}>
        {results}
        <LazyLoader />
      </GridItem>
    </GridContainer>
  </Section>
);
